var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeadControlFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8372_21505)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0634 19.0834L15.3045 10.7498C15.4928 10.0498 16.2128 9.63494 16.9128 9.82319L23.6938 11.6467C24.3938 11.835 24.8086 12.555 24.6204 13.2551L22.3793 21.5887C22.1911 22.2887 21.4709 22.7035 20.7709 22.5153L13.99 20.6917C13.29 20.5035 12.8752 19.7834 13.0634 19.0834Z",
    fill: "#1B2332",
    stroke: "#1B2332",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0508 13.2536C16.145 12.9036 16.505 12.6961 16.855 12.7903L19.6995 13.5552C20.0495 13.6494 20.257 14.0094 20.1629 14.3594C20.0687 14.7094 19.7087 14.9168 19.3587 14.8227L16.5142 14.0577C16.1642 13.9636 15.9567 13.6036 16.0508 13.2536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3952 15.6916C15.4893 15.3416 15.8494 15.1341 16.1994 15.2282L20.6693 16.4303C21.0193 16.5244 21.2267 16.8845 21.1326 17.2345C21.0385 17.5845 20.6785 17.7919 20.3285 17.6978L15.8585 16.4957C15.5085 16.4016 15.3011 16.0416 15.3952 15.6916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7396 18.13C14.8337 17.78 15.1937 17.5726 15.5437 17.6667L19.6073 18.7595C19.9573 18.8536 20.1647 19.2137 20.0706 19.5637C19.9765 19.9137 19.6165 20.1211 19.2665 20.027L15.2029 18.9342C14.8529 18.8401 14.6454 18.48 14.7396 18.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0089 11.5132C11.7678 11.5132 13.1937 10.0873 13.1937 8.32837C13.1937 6.56945 11.7678 5.14355 10.0089 5.14355C8.24999 5.14355 6.8241 6.56945 6.8241 8.32837C6.8241 10.0873 8.24999 11.5132 10.0089 11.5132Z",
    fill: "#1B2332",
    stroke: "#1B2332",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3111 20.654C10.6504 20.654 10.9296 20.3965 10.9638 20.0663L12.9257 12.7292L12.9203 12.7278C12.9344 12.6742 12.9419 12.618 12.9419 12.5601C12.9419 12.1976 12.6481 11.9038 12.2857 11.9038C10.605 11.9038 9.48421 11.9087 8.32389 11.9138L8.06743 11.9149C5.29169 11.927 3.03879 14.1769 3.03879 16.9562V19.1437C3.03879 19.9911 3.72795 20.6752 4.5723 20.6747C6.29575 20.6736 6.65287 20.669 7.01159 20.6645L7.09236 20.6634C7.47863 20.6586 7.9849 20.654 10.3111 20.654Z",
    fill: "#1B2332"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8372_21505"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.75,
    height: 19.25,
    fill: "white",
    transform: "translate(2.625 4.375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadControlFilled);
export default __webpack_public_path__ + "static/media/lead_control_filled.eaf953b4b614f487cf0ee31141687b45.svg";
export { ForwardRef as ReactComponent };